module.exports = __webpack_public_path__ + "files/1a55492ba2f68375626e80e11426fd42.png";